import createModelStore from "../../utils/createModelStore";
import Sector from "../../services/Sector";

const sectors = createModelStore<Sector.Model, "sectors">("sectors");

export default sectors;
